import React, { useState, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { Button, IconButton } from '@material-ui/core';
import { getMoney, getQuantity } from './Utils';
import { useStore } from '../useStore';
import CopyIcon from '@material-ui/icons/AddShoppingCart';
import { cartAddItemById } from '../reducers/cart';
import { withQuickshopStyles } from './styles';
import CloseIcon from '@material-ui/icons/Close';


const OrderDialog = withQuickshopStyles(({ order, classes, onClose, ...rest }) => {
  return (
    <Dialog onClose={() => onClose()} aria-labelledby="simple-dialog-title" maxWidth="md" {...rest}>
      <DialogTitle id="simple-dialog-title">
      {onClose ? (
        <IconButton aria-label="Close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
      #{order.id} - {order.status}
      </DialogTitle>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Benämning</TableCell>
            <TableCell align="right">Levererat antal</TableCell>
            <TableCell align="right">Beställt antal</TableCell>
            <TableCell>Enhet</TableCell>
            <TableCell align="right">Pris</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {order.items.map(item => (
            <TableRow key={item.id}>
              <TableCell>{item.title}</TableCell>
              <TableCell align="right">{getQuantity(parseFloat(item.quantity))}</TableCell>
              <TableCell align="right">{getQuantity(parseFloat(item.quantity_ordered))}</TableCell>
              <TableCell>{item.qos_type === 0 ? 'Kolli' : 'Styck'}</TableCell>
              <TableCell align="right">{getMoney(parseFloat(item.price))}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Dialog>
  )
})

const OrderCopyLink = ({brewery, order, dispatch}) => (
  // order.items.forEach(item => dispatch(cartAddItem(brewery, item, item.quantity)))
  <IconButton onClick={() => {dispatch(cartAddItemById(brewery, order.items.map(item => ({productId: item.product_id, quantity: parseInt(item.quantity_package)}))));}}><CopyIcon /></IconButton>
)

const OrderDialogLink = ({ order, ...rest }) => {
  const [open, setOpen] = useState(false);
  return (<>
    <Button onClick={value => setOpen(true)}>{order.id}</Button>
    <OrderDialog order={order} open={open} onClose={value => setOpen(false)} />
  </>)
}

const OrderList = ({ brewery, crud }) => {
  const { dispatch } = useStore();
  
  useEffect(() => {
    crud.getItems({
      filter: {
        brewery: brewery.id,
      }
    });
  }, []);

  if (crud.isLoading)
    return (
      <div style={{ textAlign: "center" }}>
        <CircularProgress />
      </div>
    )
  if (!crud.items)
    return (
      <Typography align="center">Inga beställningar.</Typography>
    );
  return (
    <Grid container justify="center">
      <Grid item xs={11} sm={10} md={8} lg={8} xl={8}>
        <Grid container direction="column" justify="center" alignItems="stretch" spacing={16}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center"># ID</TableCell>
                <TableCell>Datum</TableCell>
                <TableCell>Leveransdatum</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Kopiera</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {crud.items.map(order => (
                <TableRow key={order.id}>
                  <TableCell align="center"><OrderDialogLink order={order} /></TableCell>
                  <TableCell>{new Date(order.date).toLocaleDateString()}</TableCell>
                  <TableCell>{order.delivery_date && new Date(order.delivery_date).toLocaleDateString()}</TableCell>
                  <TableCell>{order.status}</TableCell>
                  <TableCell><OrderCopyLink brewery={brewery} order={order} dispatch={dispatch} /></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Grid>
      </Grid>
    </Grid>
  );
}
export default OrderList;
